export enum MandateStatus {
    FAILED = "Failed.",
    NEW = "New / not mapped.",
    EXISTS = "Data exists.",
    EXISTSUPLOAD = "Data exists, Uploaded.", /* not used? */
    EXISTSSURVEY = "Data exists, Survey.", /* not used? */
    CLOSED = "Mandate is closed.",
    UPLOADED = "Uploaded."
}